import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9aae8a3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "after-complaint" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Rules", -1))
const _hoisted_3 = { class: "after-complaint-content" }

import { reactive, ref, watch, inject, onMounted } from 'vue'
import { useRoute, useRouter } from "vue-router";
import { Toast } from 'vant';
import Header from "@/components/header/header.vue";
import afterFileRemark from "./component/afterFileRemark.vue";
import BottomBtn from "./component/afterBottomBtn.vue";
import {getFilePath, getRuleUrl} from '@/hooks/index'

export default /*#__PURE__*/_defineComponent({
  __name: 'afterSaleComplaint',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const $http: any = inject("$http");
let teaxAreaVal = ref('')
let ruleUrl = ref('')
let reason:any = ref({})
let selectAction = ref('')
let skipPath = ref('')
let showAction = ref(false)
let reasonList = ref([{}])
let imgPathData = ref({})
let btnData = reactive([
    {
        plain: true,
        textColor: '#333333',
        bordersColor: '#999999',
        radiusSize: '6px',
        title: 'Cancel',
    },
    {
        textColor: '#E04545',
        bordersColor: '#E04545',
        radiusSize: '6px',
        title: 'Submit',
        loading:false,
    },
])
/**fileStorage数组内对象： 
 * {
 * content: '', // 上传时返回的文件拼接路径
    attach_type: 1, // 文件类型 1：图片 2：视频
    }
 */
let fileStorage:any = reactive([])
const fileList = ref([]); // 视频图片有编辑的情况下反显用
onMounted(()=>{
    // 获取视频/图片拼接路径及格式信息
    getFilePath().then((res:any)=>{
        imgPathData.value = res
    })
    getRuleUrl().then((res: any) => {
        const { aftersale_rules }  = res.agreements
        ruleUrl.value = aftersale_rules.display ?   res.agreements.aftersale_rules.url : ''
    })
})
const  getReasonList = async()=>{
    const res: any = await $http.getAfterSaleReasonList({ group_code: ['appeal'] })
    if (res.code === 200) {
        reasonList.value = res.data['appeal']
    }
}
getReasonList()
const goToRule = () => {
    if(ruleUrl.value){
        window.open(ruleUrl.value)
    }
}

const changeReasonList = async () => {
    showAction.value = true
}
const handleUpload = (data: any) => {
    fileStorage.push(data)
}
const delFile = (file: any) => {
    fileStorage = file
}
const handleReasonRadio = (item: any) => {
    reason.value = item
    selectAction.value = item.id
    showAction.value = false
}
const handleBtn = async (item: any) => {
    if (item.title === "Submit") {
        btnData[1].loading = true
        let params = {
            check_id: Number(route.query.check_id || 0),//审核单ID
            check_status: 3,//审核状态1-同意;3-申诉;4-取消  列表页按钮状态
            reason_id: reason.value.id,//原因ID
            remark: teaxAreaVal.value,//备注
            attachments: fileStorage
        }
        if(!reason.value.id) { 
            Toast("please choose the reason");
            btnData[1].loading = false
            return
        }
        const res: any = await $http.setAfterSaleExpressWay(params)
        if (res.code === 200) {
            router.push(`/afterSale?name=state_all`)
        } else {
            Toast(res.msg);
        }
        btnData[1].loading = false
    } else {
        // 取消返回
        router.push(skipPath.value)
    }


}
watch(() => route.params, (newVal: any) => {
    skipPath.value = `/afterSaleDetails/${newVal.id}?&name=${route.query.name}`
}, { immediate: true })

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header, {
      title: "Reason For Complaint",
      backgroundColor: "#FFFFFF",
      fontColor: "#303133",
      skipPath: _unref(skipPath),
      ios_app: true
    }, {
      right: _withCtx(() => [
        _createElementVNode("div", {
          class: "header-right",
          onClick: goToRule
        }, [
          _createVNode(_component_van_icon, {
            name: "question-o",
            size: "0.5rem"
          }),
          _hoisted_2
        ])
      ]),
      _: 1
    }, 8, ["skipPath"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_van_field, {
        modelValue: _unref(reason).title,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(reason).title) = $event)),
        class: _normalizeClass(_unref(reason).title ? 'express-cell' : ''),
        "is-link": "",
        "input-align": "right",
        readonly: "",
        label: "Reason:",
        "label-width": "40%",
        placeholder: "plesae choose",
        onClick: changeReasonList
      }, null, 8, ["modelValue", "class"]),
      _createVNode(afterFileRemark, {
        class: "add-refund-content",
        fileList: fileList.value,
        imgPathData: _unref(imgPathData),
        teaxAreaVal: _unref(teaxAreaVal),
        "onUpdate:teaxAreaVal": _cache[1] || (_cache[1] = ($event: any) => (_isRef(teaxAreaVal) ? (teaxAreaVal).value = $event : teaxAreaVal = $event)),
        onHandleUpload: handleUpload,
        onDelFile: delFile
      }, null, 8, ["fileList", "imgPathData", "teaxAreaVal"])
    ]),
    _createVNode(BottomBtn, {
      onClick: handleBtn,
      btnData: _unref(btnData)
    }, null, 8, ["btnData"]),
    _createVNode(_component_van_action_sheet, {
      show: _unref(showAction),
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (_isRef(showAction) ? (showAction).value = $event : showAction = $event)),
      title: "Reason for return",
      closeable: false,
      round: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_radio_group, {
          modelValue: _unref(selectAction),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(selectAction) ? (selectAction).value = $event : selectAction = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_cell_group, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(reasonList), (item) => {
                  return (_openBlock(), _createBlock(_component_van_cell, {
                    title: item.title,
                    clickable: "",
                    onClick: ($event: any) => (handleReasonRadio(item))
                  }, {
                    "right-icon": _withCtx(() => [
                      _createVNode(_component_van_radio, {
                        name: item.id
                      }, null, 8, ["name"])
                    ]),
                    _: 2
                  }, 1032, ["title", "onClick"]))
                }), 256))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})